module.exports = __webpack_public_path__ + "media/images/pdf/logo_sumai_shadow-3b20313f333e18602caed6c28218671e.png";